import create from "zustand";

interface RegisterModalState {
  isOpen: boolean;
}

interface RegisterModalActions {
  onOpen: () => void;
  onClose: () => void;
}

const useRegisterModal = create<RegisterModalState & RegisterModalActions>((set) => ({
  isOpen: false,
  onOpen: () => set({ isOpen: true }),
  onClose: () => set({ isOpen: false }),
}));

export default useRegisterModal;
